const scrubString = (str) =>
  typeof str === 'string' ? str.replace(/[^0-9]+/g, '') : str;

export default scrubString;
